import React from "react";
import { client } from "../sanity/client";

import PortableText from "@sanity/block-content-to-react";
import createImageUrlBuilder from "@sanity/image-url";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import useTranslation from "next-translate/useTranslation";
import Footer from "SanityComponents/Footer/Footer";
import style from "./style.module.css";
import WhatssapComponent from "SanityComponents/WhatssapComponent";
import { externalUrl } from "utils/FormatUrl";

function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}
const serializer = {
  types: {
    mainImage: (props) => (
      <figure>
        <img
          src={urlFor(props.node.asset).width(600).height(600).url()}
          alt={props.node.alt}
        />
        <figcaption>{props.node.caption}</figcaption>
      </figure>
    ),
  },
  marks: {
    color: ({ mark, children }) => (
      <span style={{ color: mark.hex }}>{children}</span>
    ),
    link: ({ children, mark }) =>
      mark.blank ? (
        <a
          style={{
            textDecoration: "underline",
            color: "#3498db",
            cursor: "pointer",
          }}
          href={mark.href}
          target="_blank"
          rel={externalUrl(mark.href) ? "noindex, nofollow, noreferrer" : "dofollow"}
        >
          {children}
        </a>
      ) : (
        <a
          style={{
            textDecoration: "underline",
            color: "#3498db",
            cursor: "pointer",
          }}
          href={mark.href}
            rel={externalUrl(mark.href) ? "noindex, nofollow, noreferrer" : "dofollow"}
        >
          {children}
        </a>
      ),
    aligntexte: ({ children, mark }) =>
      mark.position == "1" ? (
        <span>{children}</span>
      ) : mark.position == "2" ? (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            textAlign: "center",
          }}
        >
          {children}
        </span>
      ) : (
        <span
          style={{
            display: "flex",
            justifyContent: "end",
            width: "100%",
            textAlign: "end",
          }}
        >
          {children}
        </span>
      ),
  },
};
function ConditionUtilisation(props) {
  const { t, lang } = useTranslation("common");

  const { post } = props;
  return (
    <>
      <div className={style.bodyContent}>
        <PortableText
          projectId="n2i0cmq4"
          dataset="production"
          blocks={post.post.body}
          serializers={serializer}
        />
      </div>
      {post.post?.content?.length > 0
        ? post.post.content.map((item, key) => {
            return (
              <>
                {item._type == "SanityHeadSeo" && (
                  <SanityHeadSeo
                    key={key}
                    title={item.titre ? item.titre[lang] : ""}
                    ogTitle={item.titre ? item.titre[lang] : ""}
                    description={item.description ? item.description[lang] : ""}
                    ogDescription={
                      item.description ? item.description[lang] : ""
                    }
                    canonicalUrl={item.canonicalUrl}
                    ogTwitterImage={
                      item.mainImage
                        ? urlFor(item.mainImage)
                            .width(250)
                            .height(250)
                            .format("webp")
                            .auto("format")
                            .fit("scale")
                            .auto("format")
                            .toString()
                        : null
                    }
                    ogType={item.ogType}
                    ogImageUrl={
                      item.mainImage
                        ? urlFor(item.mainImage)
                            .width(250)
                            .height(250)
                            .format("webp")
                            .auto("format")
                            .fit("scale")
                            .auto("format")
                            .toString()
                        : null
                    }
                    structuredData={null}
                  >
                    <></>
                  </SanityHeadSeo>
                )}
                { (item._type == "WhatssapComponent") ?
                <WhatssapComponent
                  number={item?.numberPhone ? item.numberPhone : null}
                  message={item?.message ? item.message[lang] : null}
                />
                :null}
                {item._type == "SanityFooter" && (
                  <div className={style.footer}>
                    <div className={style.footerDesk}>
                      <Footer
                        propos={item.propos[lang]}
                        proposText={item.text ? item.text[lang] : ""}
                        donnee={item.donnees[lang]}
                        donneeText={item.textdonnee[lang]}
                        technologie={item.technologie[lang]}
                        technologieText={item.texttechnologies[lang]}
                        logo={urlFor(item.agenz_logo)
                          .format("webp")
                          .auto("format")
                          .fit("scale")
                          .auto("format")
                          .toString()}
                        facebook={urlFor(item.facebook_logo)
                          .format("webp")
                          .auto("format")
                          .fit("scale")
                          .auto("format")
                          .toString()}
                        instagram_logo={urlFor(item.instagram_logo)
                          .format("webp")
                          .auto("format")
                          .fit("scale")
                          .auto("format")
                          .toString()}
                        linked_in={urlFor(item.linkedin_logo)
                          .format("webp")
                          .auto("format")
                          .fit("scale")
                          .auto("format")
                          .toString()}
                        socialMediaText={item.socialMediatext}
                        copyRightText={item.permission_text}
                      />
                    </div>
                  </div>
                )}
              </>
            );
          })
        : null}
    </>
  );
}

export default ConditionUtilisation;
